import { forLoggedInUser } from '../channels';
import { Joi, actionCreator, objectSchemaOf } from '../helpers';
import { PRESENCE_OUTPUT } from './topics';

export const EXPIRED = 'PRESENCE/EXPIRED' as const;

export interface IExpiredActionPayload {
  uid: string;
  sessionId: string;
}

export interface IExpiredAction {
  type: typeof EXPIRED;
  payload: IExpiredActionPayload;
}

export const expiredActionPayloadSchema = objectSchemaOf<IExpiredActionPayload>(
  {
    uid: Joi.string().required(),
    sessionId: Joi.string().required(),
  }
);

export const expiredActionSchema = objectSchemaOf<IExpiredAction>({
  type: Joi.string().valid(EXPIRED).required(),
  payload: expiredActionPayloadSchema.required(),
});

/**
 * Indicates that an old browser tab session has expired
 * and should not pruduce more NOTIFY events
 */
export const expired = actionCreator({
  type: EXPIRED,
  topic: PRESENCE_OUTPUT,
  schema: expiredActionSchema,
  channels: [forLoggedInUser],
});
